// extracted by mini-css-extract-plugin
export default {"businessUsers":"SideNavSettings_businessUsers__fP0x7","badge":"SideNavSettings_badge__1cbBn"};